import React from "react";
import { Link } from "react-router-dom";
import CcgRoutePremiumPage from "../components/CcgRoutePremiumPage";
import PostcodeQuotenew from "./PostcodeQuotenew";
import "./CcgRoutePremium.css";

const cardGrid = (className, cards) => (
  <div className={className}>
    {cards.map((card) => (
      <article className={card.className || ""} key={card.title}>
        <h3>{card.title}</h3>
        {card.body ? <p>{card.body}</p> : null}
        {card.items ? <ul>{card.items.map((item) => <li key={item}>{item}</li>)}</ul> : null}
        {card.link ? <Link to={card.link.to} className={card.link.className || "route-link-inline"}>{card.link.label}</Link> : null}
        {card.links ? <div className="route-link-btn-row">{card.links.map((link) => <Link to={link.to} className={link.className || "route-link-btn"} key={link.to}>{link.label}</Link>)}</div> : null}
      </article>
    ))}
  </div>
);

const taplowToHeathrowRoute = {
  id: "taplow-to-heathrow",
  path: "/taplow-to-heathrow",
  liveStripVariant: "maidenhead",
  seo: {
    title: "Taplow to Heathrow Taxi - Fixed-Price Airport Transfers | CheapCabGrab",
    description:
      "Book a fixed-price taxi from Taplow to Heathrow. Taplow station, Cliveden and Thames-side pickup options with licensed drivers, flight tracking and no surge pricing.",
    keywords:
      "Taplow to Heathrow taxi, Taplow station to Heathrow taxi, Cliveden to Heathrow taxi, Taplow airport transfer, Taplow Heathrow transfer, CheapCabGrab",
    canonical: "https://www.cheapcabgrab.com/taplow-to-heathrow",
    ogTitle: "Taplow to Heathrow Taxi - Fixed Airport Transfers",
    ogDescription:
      "Reliable Taplow to Heathrow taxis with fixed fares, licensed drivers and live flight tracking. Book online in seconds with CheapCabGrab.",
    serviceName: "CheapCabGrab - Taplow to Heathrow Taxi",
    areaServed: ["Heathrow Airport", "Taplow", "Taplow Station", "Cliveden", "Maidenhead Bridge"],
    offerCatalogName: "Taplow to Heathrow Taxi Routes",
    offerName: "Taplow to Heathrow Airport fixed-price taxi",
    offerDescription: "Fixed-price taxi transfers from Taplow to Heathrow Airport terminals with licensed drivers and flight tracking.",
    reservationName: "Taxi booking from Taplow to Heathrow",
  },
  hero: {
    eyebrow: "Taplow to Heathrow taxi route",
    h1: "Taplow to Heathrow Taxi - Fixed-Price Airport Transfers",
    subtitle: "Taplow station, Cliveden and Thames-side pickups for Heathrow terminals 2, 3, 4 and 5.",
    body:
      "Book reliable taxis from Taplow to Heathrow with licensed drivers, flight tracking and secure online booking. Fixed upfront fares with no surge pricing.",
  },
  quote: {
    label: "Get instant quotes",
    note: "Free - Fast - No obligation",
    presetPickup: "Taplow, SL6",
    presetDropoff: "Heathrow Airport",
  },
  flags: [
    "Fixed fares agreed upfront - no meters",
    "Live flight tracking for Heathrow arrivals",
    "Taplow station, Cliveden and hotel pickups",
    "Saloon, MPV, minibus and coach options",
  ],
  reviewPageKey: "/taplow-to-heathrow",
  reviewAriaLabel: "Taplow to Heathrow customer reviews",
  lhrStatusTitle: "Live Heathrow checks for Taplow to Heathrow taxis",
  floatingCta: "Book Taplow to Heathrow Taxi",
  mobileCta: "Book Taplow to Heathrow Taxi",
  supportNudge: "Need Taplow to Heathrow help?",
  sections: [
    {
      id: "route-overview",
      title: "Taplow to Heathrow at a glance",
      body: "A practical airport route for Taplow homes, station connections, Cliveden stays and Thames-side hotel guests.",
      render: () => cardGrid("route-overview-grid", [
        {
          title: "Journey basics",
          items: [
            "Distance: Approx. 14-20 miles depending on pickup point and terminal",
            "Typical time: 25-45 minutes",
            "Typical saloon fare: from GBP45-GBP70",
            "Areas covered: Taplow, Cliveden, Maidenhead Bridge, Dorney edge and nearby SL6 pickups",
          ],
        },
        {
          title: "Great for",
          items: [
            "Heathrow departures from Taplow station or homes",
            "Cliveden and riverside hotel airport transfers",
            "Families with luggage or child seats",
            "Business travellers needing fixed fares and receipts",
          ],
        },
        {
          title: "Local planning links",
          links: [
            { to: "/taplow-taxi", label: "Taplow taxi" },
            { to: "/maidenhead-to-heathrow", label: "Maidenhead to Heathrow", className: "route-link-btn route-link-btn-secondary" },
          ],
        },
      ]),
    },
    {
      id: "route-tools",
      title: "Useful tools for your Taplow to Heathrow journey",
      body: "Check terminals, live Heathrow status and airport transfer options before you travel.",
      render: () => cardGrid("route-links-grid", [
        { title: "Heathrow Terminal Finder", body: "Check the correct Heathrow terminal before booking or travelling.", link: { to: "/terminalFinder", label: "Open Terminal Finder", className: "route-link-btn" } },
        { title: "Heathrow hotel guide", body: "Useful if your Taplow pickup connects to a Heathrow hotel or onward terminal transfer.", link: { to: "/heathrow-hotels", label: "See Heathrow hotels", className: "route-link-btn" } },
        { title: "Group travel", body: "Need more luggage space from Taplow? Use minibus or coach options for groups.", links: [{ to: "/minibus", label: "Minibus" }, { to: "/coach", label: "Coach", className: "route-link-btn route-link-btn-secondary" }] },
      ]),
    },
    {
      id: "route-faq",
      title: "Taplow to Heathrow taxi - FAQs",
      body: "Common questions for Taplow airport transfers.",
      render: () => (
        <div className="route-faq-grid">
          {[
            ["How long does Taplow to Heathrow take?", "Most Taplow to Heathrow taxi journeys take around 25-45 minutes, depending on traffic, pickup point and terminal."],
            ["Can you pick up from Taplow station?", "Yes. Taplow station is a regular pickup point for Heathrow transfers and local onward journeys."],
            ["Can you collect from Cliveden?", "Yes. We handle Heathrow transfers from Cliveden and nearby Thames-side locations for guests, events and leisure stays."],
            ["Do you track Heathrow flights?", "Yes. For Heathrow pickups we monitor your flight and adjust dispatch timing where possible."],
          ].map(([title, body]) => <article className="route-faq-card" key={title}><h3>{title}</h3><p>{body}</p></article>)}
        </div>
      ),
    },
  ],
};

const TaplowToHeathrow = () => (
  <CcgRoutePremiumPage route={taplowToHeathrowRoute} QuoteComponent={PostcodeQuotenew} />
);

export default TaplowToHeathrow;
